import { fetchUrl } from "@/constants/fetchUrl";
import { fetchGet } from "../generalFetch";
import request, { post } from "@/services/request";

export default {
  async getClients(payload) {
    const url = fetchUrl["clients"];
    const clients = await fetchGet(url, payload, "clients");
    return clients;
  },
  async getClientContracts(payload) {
    const url = `${fetchUrl["clientContracts"]}${payload.id}`;
    const key = `contracts__client__${payload.id}`;
    const contracts = await fetchGet(url, payload, key);
    return contracts;
  },
  async saveContract(data) {
    return post(`/tenant/contracts`, data);
  },
  async itinerary_section_list(clientId, lang) {
    return request({
      method: "GET",
      url: `/tenant/clients/${clientId}/itinerary_sections`,
      params: {
        lang,
      },
    });
  },
};
